import styled from "styled-components";

const ContenedorGeneralInicio = styled.div`
  display: flex;
  flex-direction: column;
`;

export default ContenedorGeneralInicio;